import { MessageToMerchant } from "../remoteAction";

export type SendIsReadyAction = MessageToMerchant<"SET_WIDGET_READY", boolean>;

export function sendIsReady(isReady: boolean = true): SendIsReadyAction {
  return {
    type: "SEND_MESSAGE_TO_MERCHANT",
    payload: {
      type: "SET_WIDGET_READY",
      data: isReady,
    },
  };
}
